import { Injectable } from "@angular/core";
import swal from "sweetalert2";

declare const $: any;

@Injectable({
  providedIn: "root",
})
export class View {
  constructor() {}

  showMessage(text: string, type: string = "") {
    swal({
      title: "Aviso",
      // text: text,
      html: text,
      buttonsStyling: false,
      confirmButtonClass: "btn btn-success",
    }).catch(swal.noop);
  }

  showConfirm(
    text: string,
    confirm,
    cancel = () => {},
    extraParams: { confirmarText?: string; cancelarText?: string } = {}
  ) {
    swal({
      title: text,
      // text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: extraParams.confirmarText || "Confirmar",
      cancelButtonText: extraParams.cancelarText || "Cancelar",
    }).then((result) => {
      if (result.value) {
        confirm();
      } else {
        cancel();
      }
    });
  }

  showTextArea(text: string, confirm, cancel = () => {}, validator = (value) => "", inputValue = "") {
    swal({
      title: text,
      input: "textarea",
      inputValue,
      inputPlaceholder: "Descreva seu texto...",
      inputAttributes: {
        "aria-label": "Descreva seu texto",
      },
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      inputValidator: validator,
    }).then((result) => {
      if (result.value) {
        confirm(result.value);
      } else {
        cancel();
      }
    });
  }

  showToast(texto: string, type: "success" | "danger" = "success") {
    $.notify(
      {
        icon: "notifications",
        message: texto,
      },
      {
        type: type,
        timer: 7000,
        placement: {
          from: "top",
          align: "center",
        },
        template:
          '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          "</div>" +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
          "</div>",
      }
    );
  }

  showInput(text: string, confirm, type: any = "text", inputValue = "", validator = (value) => "", cancel = () => {}) {
    swal({
      title: text,
      input: type,
      inputValue: inputValue || "",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      inputValidator: validator,
    }).then((result) => {
      if (result.value) {
        confirm(result.value);
      } else {
        cancel();
      }
    });
  }
}
